import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAuth from '../../hooks/useAuth';
import { useNotifications } from '../../context/NotificationContext';
import Field from '../common/Field';
import { validate, isEmail, isStrongPassword, isPhone, minLength, isNotBlank } from '../../utils/validators';

const EMPTY = {
  firstName: '', lastName: '', email: '', password: '', phoneNumber: '',
  address: '', city: '', state: '', zipCode: '',
};

export default function ClientRegistration() {
  const { t } = useTranslation();
  const { registerClient } = useAuth();
  const notify = useNotifications();
  const navigate = useNavigate();
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    const req = t('common.required');
    const errs = validate(form, {
      firstName: [[(v) => minLength(v, 2), req]],
      lastName: [[(v) => minLength(v, 2), req]],
      email: [[isEmail, req]],
      password: [[isStrongPassword, t('auth.passwordRule')]],
      phoneNumber: [[isPhone, '+243…']],
      address: [[isNotBlank, req]],
      city: [[isNotBlank, req]],
    });
    setErrors(errs);
    if (Object.keys(errs).length) return;

    setBusy(true);
    try {
      const user = await registerClient({
        ...form,
        state: form.state || form.city,
        zipCode: form.zipCode || '0000',
      });
      notify.success(t('auth.welcomeBack', { name: user.firstName }));
      navigate('/client', { replace: true });
    } catch (err) {
      notify.apiError(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit}>
      <div className="form-grid">
        <Field label={t('auth.firstName')} value={form.firstName} onChange={set('firstName')} error={errors.firstName} />
        <Field label={t('auth.lastName')} value={form.lastName} onChange={set('lastName')} error={errors.lastName} />
        <Field label={t('auth.email')} type="email" value={form.email} onChange={set('email')} error={errors.email} />
        <Field label={t('auth.password')} type="password" value={form.password} onChange={set('password')} error={errors.password} />
        <Field label={t('auth.phone')} placeholder="+243 …" value={form.phoneNumber} onChange={set('phoneNumber')} error={errors.phoneNumber} />
        <div />
        <Field label={t('auth.address')} value={form.address} onChange={set('address')} error={errors.address} />
        <Field label={t('auth.city')} value={form.city} onChange={set('city')} error={errors.city} placeholder="Kinshasa" />
        <Field label={`${t('auth.state')} (${t('common.optional')})`} value={form.state} onChange={set('state')} />
        <Field label={`${t('auth.zip')} (${t('common.optional')})`} value={form.zipCode} onChange={set('zipCode')} />
      </div>
      <button className="btn block" disabled={busy}>
        {busy ? t('common.loading') : t('auth.createClientAccount')}
      </button>
    </form>
  );
}
